import moment from 'moment'
import pdfMake from 'pdfmake/build/pdfmake'
import pdfFonts from 'pdfmake/build/vfs_fonts'

pdfMake.vfs = pdfFonts.pdfMake.vfs

const gerarPDFEncomendas = ({ dataSource, filtrosDetalhados = [], reportName, title, sumData = [] }) => {
  if (!Array.isArray(dataSource) || dataSource.length === 0) {
    throw new Error('dataSource deve ser um array válido com pelo menos um elemento.')
  }

  const reportTimeStamp = moment().format('DD_MM_YYYY_HH_mm_ss')

  const formatarData = (dataStr) => {
    if (!dataStr) return 'N/A'
    return moment(dataStr).format('DD/MM/YYYY HH:mm:ss')
  }

  const gerarLinhasTabela = (item, nivel = 0) => {
    const linhas = [
      [
        { text: '  '.repeat(nivel) + item.qtd.toFixed(3), alignment: 'right' },
        { text: '  '.repeat(nivel) + item.descricao },
        { text: item.sigla || 'UN', alignment: 'center' }
      ]
    ]

    ;['subitens', 'sub_subitens'].forEach((key) => {
      if (Array.isArray(item[key])) {
        item[key].forEach((subitem) => {
          linhas.push(...gerarLinhasTabela(subitem, nivel + 1))
        })
      }
    })

    return linhas
  }

  const criarCabecalho = () => [
    {
      bold: true,
      text: `EasyAssist Web - ${title}`,
      fontSize: 10,
      marginBottom: 2
    },
    ...filtrosDetalhados.map((detalhe) => ({ text: detalhe, fontSize: 9 })),
    {
      margin: [0, 5, 0, 10],
      text: `Gerado em: ${moment().format('DD/MM/YYYY HH:mm:ss')}`,
      bold: true,
      fontSize: 9
    },
    {
      canvas: [{ type: 'line', x1: 0, y1: 0, x2: 520, y2: 0, lineWidth: 1 }],
      marginBottom: 10
    }
  ]

  const criarConteudoPedidos = () =>
    dataSource.flatMap((pedido, index) => [
      {
        text: `Pedido ${index + 1} de ${dataSource.length}`,
        style: 'pedidoHeader',
        marginBottom: 4
      },
      {
        style: 'infoSection',
        columns: [
          {
            width: '*',
            stack: [
              { text: [{ text: 'Senha: ', bold: true }, pedido.senhacomanda] },
              {
                text: [{ text: 'Cliente: ', bold: true }, pedido.nomeourazaosocial]
              },
              { text: [{ text: 'Telefone: ', bold: true }, pedido.telefone] },
              pedido.rua
                ? {
                    text: [
                      { text: 'Endereço: ', bold: true },
                      `${pedido.rua}, ${pedido.endereco_numero} - ${pedido.bairro}, ${pedido.cidade}`
                    ],
                    margin: [0, 2, 0, 0]
                  }
                : { text: 'Endereço: Não informado' }
            ].filter(Boolean)
          },
          {
            width: 'auto',
            stack: [
              {
                text: [{ text: 'Data do Pedido: ', bold: true }, formatarData(pedido.dthrpedido)]
              },
              {
                text: [{ text: 'Data de Entrega: ', bold: true }, formatarData(pedido.dthrentrega)]
              }
            ]
          }
        ]
      },
      pedido.observacoes_finalizadoras && {
        style: 'obsSection',
        margin: [0, 10, 0, 10],
        text: [
          { text: 'Forma de Pagamento: ', bold: true },
          pedido.observacoes_finalizadoras && pedido.observacoes_finalizadoras.length > 0
            ? pedido.observacoes_finalizadoras.map((obs) => obs.descricao).join(', ')
            : 'Não Informado'
        ]
      },

      {
        style: 'itemsTable',
        table: {
          headerRows: 1,
          widths: ['auto', '*', 'auto'],
          body: [
            [
              { text: 'Qtd', style: 'tableHeader' },
              { text: 'Descrição', style: 'tableHeader' },
              { text: 'Un', style: 'tableHeader' }
            ],
            ...(pedido.itens ? pedido.itens.flatMap((item) => gerarLinhasTabela(item)) : [])
          ]
        },
        layout: 'lightHorizontalLines'
      },
      {
        canvas: [{ type: 'line', x1: 0, y1: 0, x2: 520, y2: 0, lineWidth: 1 }],
        margin: [0, 10, 0, 10]
      }
    ])

  const criarSumarioProdutos = () => {
    if (!sumData || sumData.length === 0) {
      return []
    }

    return sumData.flatMap((section) => {
      const { title: sectionTitle, columns, dataSource: sectionData } = section

      if (!sectionData || sectionData.length === 0) {
        return []
      }

      const tableWidths = columns.map((_, idx) => (idx === 0 ? '*' : 'auto'))

      const headerRow = columns.map((col) => {
        const isQty = col.title.toLowerCase().includes('qtd') || col.title.toLowerCase().includes('total')
        const isUnit = col.title.toLowerCase().includes('und')

        let alignment = 'left'
        alignment = isQty ? 'right' : alignment
        alignment = isUnit ? 'center' : alignment

        return {
          text: col.title,
          style: 'tableHeader',
          alignment
        }
      })

      const bodyRows = sectionData.map((row) =>
        columns.map((col) => {
          const value = row[col.dataIndex]
          const isNumber = typeof value === 'number' || !Number.isNaN(parseFloat(value))

          const align = isNumber ? 'right' : 'left'
          const displayValue = typeof value === 'number' ? value.toFixed(3) : value || 'N/A'
          const finalAlign = col.dataIndex === 'unidade' ? 'center' : align

          return {
            text: displayValue,
            alignment: finalAlign
          }
        })
      )

      return [
        {
          text: sectionTitle?.toUpperCase() || 'SUMÁRIO',
          style: 'mainHeader',
          margin: [0, 10, 0, 5]
        },
        {
          style: 'itemsTable',
          table: {
            headerRows: 1,
            widths: tableWidths,
            body: [headerRow, ...bodyRows]
          },
          layout: 'lightHorizontalLines'
        }
      ]
    })
  }

  const docDefinition = {
    content: [...criarCabecalho(), ...criarConteudoPedidos(), ...criarSumarioProdutos()],
    styles: {
      pedidoHeader: { bold: true, fontSize: 10 },
      infoSection: { fontSize: 9 },
      itemsTable: { fontSize: 9 },
      tableHeader: { bold: true, fontSize: 9 },
      mainHeader: { bold: true, fontSize: 12, marginBottom: 10 },
      fieldLabel: { fontWeight: 'bold', fontSize: 9 },
      infoText: { fontSize: 9 },
      obsSection: { fontSize: 10, backgroundColor: 'red' }
    }
  }

  pdfMake.createPdf(docDefinition).download(`${reportName}_${reportTimeStamp}.pdf`)
}

export default gerarPDFEncomendas
